import { render, staticRenderFns } from "./MacroDialog.vue?vue&type=template&id=0b8ab644&scoped=true&"
import script from "./MacroDialog.vue?vue&type=script&lang=js&"
export * from "./MacroDialog.vue?vue&type=script&lang=js&"
import style0 from "./MacroDialog.vue?vue&type=style&index=0&id=0b8ab644&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8ab644",
  null
  
)

export default component.exports